import {METHODS} from '../../constants';
import {get, makeUrl} from '../../utils/fetcher';
import {
  setError,
  setLoading,
  setDefaultMappings,
} from './slice';

export const fetchDefaultMapping = async(dispatch: any) => {
  dispatch(setLoading(true));

  const url = makeUrl(METHODS.GET_BUILT_IN_DATA_FIELD_MAPPINGS);
  const response = await get(url, dispatch, true);

  try {
    const mappings = response.data;

    dispatch(setDefaultMappings(mappings));
  } catch (error: any) {
    dispatch(setError(error.message));
    // eslint-disable-next-line no-console
    console.error('Failed to fetch mappings', error);
  } finally {
    dispatch(setLoading(false));
  }
};
